import { Quiz } from "../components/quiz/quiz"

export const Home = () =>{

    return(
        <>
            <Quiz/>
        </>
    )
}